export const statusTicketsConst = {
    "A": 0, 
    "ER": 1,
    "R": 2,
    "C": 3,
    "PS": 4,
    "PC":5
}


// WEBPACK FOOTER //
// ./src/constantes.js